const Description = () => {
  return (
    <div className="bg-white">
      <div className="container flex flex-col items-start gap-[12px] md:gap-[16px] py-[48px] md:py-[80px]">
        <h2 className="font-[500] text-[28px] md:text-[36px] leading-[36px] md:leading-[48px] text-[#000000]">Ի՞նչ է CTV գովազդը</h2>
        <div className="flex flex-col gap-[8px]">
          <p className="font-[500] text-[16px] md:text-[18px] leading-[24px] md:leading-[28px] text-[#1f2937]">
            Հեռուստատեսային էկրան. թվային ճշգրտություն
          </p>
          <p className="text-[14px] md:text-[16px] leading-[22px] md:leading-[26px] text-[#4b5563] text-justify">
            CTV (connected TV) գովազդը հնարավորություն է տալիս բրենդին ներկայանալ ինտերնետին միացված հեռուստացույցներում՝ Smart TV-ներում, սթրիմինգային հարթակներում և YouTube-ի TV տարբերակում։ Այս ձևաչափը համադրում է հեռուստատեսային մեծ էկրանի ազդեցությունն ու թվային գովազդի ճշգրիտ
            թիրախավորումը՝ ապահովելով ավելի տեսանելի, պրեմիում և ուշադրություն գրավող ներկայություն։ Ի տարբերություն ավանդական TV գովազդի՝ CTV-ն թույլ
            է տալիս հասնել կոնկրետ լսարանների, վերահսկել ցուցադրումները և չափել արշավի արդյունավետությունը։ Արդյունքում այն դառնում է արդյունավետ
            լուծում բրենդի ճանաչելիությունը բարձրացնելու, որակյալ reach ապահովելու և լսարանի հետ ավելի ուժեղ կապ ձևավորելու համար։
          </p>
        </div>
      </div>
    </div>
  );
};

export default Description;
